module.exports = __webpack_public_path__ + "img/p2_r.1767c76d.jpg";